// removed by extract-text-webpack-plugin
module.exports = {"rupee-sign":"_3HD-","has-val":"_eI4F","pos-r":"_3bIa","amt-label":"_1lmX","ibl":"_1HgQ","tr":"_3zLd","clear":"_2zvE","ib":"_39Fc"};


//////////////////
// WEBPACK FOOTER
// ./form/components/inputs/default-amount/style.css
// module id = DudR
// module chunks = 4